import { render, staticRenderFns } from "./sumList.vue?vue&type=template&id=48dbb6cc&scoped=true&"
import script from "./sumList.vue?vue&type=script&lang=js&"
export * from "./sumList.vue?vue&type=script&lang=js&"
import style0 from "./sumList.vue?vue&type=style&index=0&id=48dbb6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dbb6cc",
  null
  
)

export default component.exports